var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class FrontPage2 extends Component {
    constructor() {
        super('FrontPage2', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.home .carousel').on('slide.bs.carousel', (event) => {
                this.updateBackgroundLuminance(event.relatedTarget);
            });
            this.updateBackgroundLuminance('.home .carousel-item.active');
            $('.bloc.has-text a.title').on('mouseenter', (event, title) => {
                title.next().find('.single-hover-container').addClass('hover');
            }).on('mouseleave', (event, title) => {
                title.next().find('.single-hover-container').removeClass('hover');
            });
            ;
            $(window).on('scroll', () => {
                const windowHeight = $(window).height();
                $('.bloc .arrow-right').each((arrowRight, index) => {
                    const parent = arrowRight.parent();
                    const reference = parent.hasClass('bloc-image') ? parent.find('.images') : parent;
                    let bottom = 15;
                    let parentBottom = parent.viewportPosition().y + parent.height();
                    if (parentBottom > windowHeight) {
                        bottom = parentBottom - windowHeight + 15;
                    }
                    if (bottom + arrowRight.height() > reference.height() - 15)
                        bottom = reference.height() - 15 - arrowRight.height();
                    arrowRight.css({
                        'bottom': bottom
                    });
                });
            });
            this.success();
        });
    }
    updateBackgroundLuminance(target) {
        $('.home .carousel').css('--background-luminance', $(target).css('--background-luminance'));
    }
}
